export class PollOptionsModel {
    option: string;
}


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/models/poll-options.ts